import { render } from "./ViewNotification.vue?vue&type=template&id=0b64b9b9&scoped=true"
import script from "./ViewNotification.vue?vue&type=script&lang=js"
export * from "./ViewNotification.vue?vue&type=script&lang=js"

import "./ViewNotification.vue?vue&type=style&index=0&id=0b64b9b9&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b64b9b9"]])

export default __exports__